<template>
    <v-layout>
        <v-container fluid>
            <template>
                <v-container fluid>
                    <v-row>
                        <v-col cols="8">
                            <v-btn class="ml-20 mr-20" small rounded outlined @click="getOffers">
                                <v-icon small>mdi-refresh</v-icon>&nbsp;
                                Обновить список
                            </v-btn>
                            <v-btn class="ml-20 mr-20" small rounded outlined @click="visibility.importSetting = true">
                                <v-icon small>mdi-settings</v-icon>&nbsp;
                                Настроить импорт
                            </v-btn>
                            <v-btn class="ml-20 mr-20" small rounded outlined @click="visibility.exportSettings = true">
                                Параметры экспорта
                            </v-btn>
                            <v-btn class="ml-20 mr-20" small rounded outlined @click="massiveUpdate"
                                   :disabled="!selected.length">
                                <v-icon small>mdi-pencil</v-icon>&nbsp;
                                Массовые изменения
                            </v-btn>
                        </v-col>
                        <v-col cols="4">

                            <v-btn class="ml-20 mr-20" small rounded outlined @click="validateFeeds()">
                                Валидировать фиды
                            </v-btn>

                            <v-btn class="ml-20 mr-20" small rounded outlined color="red"
                                   v-if="$store.getters.currentUser.superuser" @click="importFeeds()">
                                <v-icon small>mdi-cloud-download</v-icon>&nbsp;
                                Обновить фиды
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container fluid>
                    <table-header
                        :data="{}"
                        :loading="loading"
                        :hasFilters="true"
                        :selectManyFilters.sync="filterOptions"
                        :filtersEnabledCount="filtersEnabledCount"
                        @clearFilters="clearFilters"
                        @clearFilter="clearFilter"
                        @onChangedFilters="onChangedFilters"
                    />
                </v-container>

                <v-data-table
                    :headers="headers"
                    :items="offers"
                    :options.sync="options"
                    :server-items-length="totalFeeds"
                    :items-per-page="itemsPerPage"
                    :footer-props="footerProps"
                    :page.sync="page"
                    dense
                    multi-sort
                    :expanded.sync="expanded"

                    :loading="loading"
                    item-key="id"
                    v-model="selected"
                    show-select
                    loading-text="Данные загружаются..."
                >
                    <template v-slot:item.building_name="props">
                        {{ props.item.building_name ? props.item.building_name : 'Не задано'}}
                    </template>

                    <template v-slot:item.price="props">
                        <v-edit-dialog
                            :return-value.sync="props.item.price"
                            large
                            save-text="Сохранить"
                            cancel-text="Отмена"
                            @save="saveFeedQuick(props.item, 'price')"
                        >
                            {{ props.item.price ? new Intl.NumberFormat().format(props.item.price) : 'Н/Д'}}
                            <template v-slot:input>
                                <v-text-field
                                    type="number"
                                    v-model.number="props.item.price"
                                    label="Цена"
                                ></v-text-field>

                            </template>
                        </v-edit-dialog>
                    </template>

                    <template v-slot:item.area="props">
                        <v-edit-dialog
                            :return-value.sync="props.item.area"
                            large
                            save-text="Сохранить"
                            cancel-text="Отмена"
                            @save="saveFeedQuick(props.item, 'area')"
                        >
                            {{ props.item.area ? new Intl.NumberFormat().format(props.item.area) : 'Н/Д'}}
                            <template v-slot:input>
                                <v-text-field
                                    type="number"
                                    v-model.number="props.item.area"
                                    label="Общая площадь"
                                    @blur="setMinValArea(props.item)"
                                    :rules="[rules.checkArea(props.item)]"
                                    :min="setMinArea(props.item)"
                                ></v-text-field>

                            </template>
                        </v-edit-dialog>
                    </template>

                    <template v-slot:item.living_space="props">
                        <v-edit-dialog
                            :return-value.sync="props.item.living_space"
                            large
                            save-text="Сохранить"
                            cancel-text="Отмена"
                            @save="saveFeedQuick(props.item, 'living_space')"
                        >
                            {{ props.item.living_space ? new Intl.NumberFormat().format(props.item.living_space) :
                            'Н/Д'}}
                            <template v-slot:input>
                                <v-text-field
                                    type="number"
                                    v-model.number="props.item.living_space"
                                    label="Жилая площадь"
                                ></v-text-field>

                            </template>
                        </v-edit-dialog>
                    </template>

                    <template v-slot:item.kitchen_space="props">
                        <v-edit-dialog
                            :return-value.sync="props.item.kitchen_space"
                            large
                            save-text="Сохранить"
                            cancel-text="Отмена"
                            @save="saveFeedQuick(props.item, 'kitchen_space')"
                        >
                            {{ props.item.kitchen_space ? new Intl.NumberFormat().format(props.item.kitchen_space) :
                            'Н/Д'}}
                            <template v-slot:input>
                                <v-text-field
                                    type="number"
                                    v-model.number="props.item.kitchen_space"
                                    label="Площадь кухни"
                                ></v-text-field>

                            </template>
                        </v-edit-dialog>
                    </template>

                    <template v-slot:item.rooms="props">
                        <v-edit-dialog
                            :return-value.sync="props.item.rooms"
                            large
                            save-text="Сохранить"
                            cancel-text="Отмена"
                            @save="saveFeedQuick(props.item, 'rooms')"
                        >
                            {{ props.item.rooms ? props.item.rooms: 'Н/Д'}}
                            <template v-slot:input>
                                <v-text-field
                                    type="number"
                                    v-model.number="props.item.rooms"
                                    label="Комнатность"
                                ></v-text-field>

                            </template>
                        </v-edit-dialog>
                    </template>

                    <template v-slot:item.floor="props">
                        <v-edit-dialog
                            :return-value.sync="props.item.floor"
                            large
                            save-text="Сохранить"
                            cancel-text="Отмена"
                            @save="saveFeedQuick(props.item, 'floor')"
                        >
                            {{ props.item.floor ? props.item.floor: 'Н/Д'}}
                            <template v-slot:input>
                                <v-text-field
                                    type="number"
                                    v-model.number="props.item.floor"
                                    label="Этаж"
                                    @blur="setMaxValFloor(props.item)"
                                    :rules="[rules.checkFloor(props.item)]"
                                    :max="setMaxFloor(props.item)"
                                ></v-text-field>

                            </template>
                        </v-edit-dialog>
                    </template>

                    <template v-slot:item.floors_total="props">
                        <v-edit-dialog
                            :return-value.sync="props.item.floors_total"
                            large
                            save-text="Сохранить"
                            cancel-text="Отмена"
                            @save="saveFeedQuick(props.item, 'floors_total')"
                        >
                            {{ props.item.floors_total ? props.item.floors_total: 'Н/Д'}}
                            <template v-slot:input>
                                <v-text-field
                                    type="number"
                                    v-model.number="props.item.floors_total"
                                    label="Этажность"
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <template v-slot:item.mortgage="props">
                        <v-edit-dialog
                            :return-value.sync="props.item.mortgage"
                            large
                            save-text="Сохранить"
                            cancel-text="Отмена"
                            @save="saveFeedQuick(props.item, 'mortgage')"
                        >
                            {{ props.item.mortgage == 1 ? 'Да' : props.item.mortgage == 0 ? 'Нет' : 'Н/Д' }}
                            <template v-slot:input>
                                <v-autocomplete
                                    :items="[{value: 0, text: 'Нет'},{value: 1, text: 'Да'}]"
                                    v-model="props.item.mortgage"
                                    label="Ипотека"
                                ></v-autocomplete>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <template v-slot:item.built_year="props">
                        <v-edit-dialog
                            :return-value.sync="props.item.built_year"
                            large
                            save-text="Сохранить"
                            cancel-text="Отмена"
                            @save="saveFeedQuick(props.item, 'built_year')"
                        >
                            {{ props.item.built_year ? props.item.built_year: 'Н/Д'}}
                            <template v-slot:input>
                                <v-text-field
                                    type="number"
                                    v-model.number="props.item.built_year"
                                    label="Год сдачи/постройки"
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <template v-slot:item.building_state="props">
                        <v-edit-dialog
                            :return-value.sync="props.item.building_state"
                            large
                            save-text="Сохранить"
                            cancel-text="Отмена"
                            @save="saveFeedQuick(props.item, 'building_state')"
                        >
                            {{ buildingStateTitle(props.item.building_state) }}
                            <template v-slot:input>
                                <v-autocomplete
                                    :items="buildingStateChoices"
                                    v-model="props.item.building_state"
                                    label="Стадия строительства"
                                ></v-autocomplete>
                            </template>
                        </v-edit-dialog>
                    </template>

                    <template v-slot:item.ready_quarter="props">
                        <v-edit-dialog
                            :return-value.sync="props.item.ready_quarter"
                            large
                            save-text="Сохранить"
                            cancel-text="Отмена"
                            @save="saveFeedQuick(props.item, 'ready_quarter')"
                        >
                            {{ props.item.ready_quarter ? props.item.ready_quarter: 'Н/Д'}}
                            <template v-slot:input>
                                <v-autocomplete
                                    :items="quarterChoices"
                                    v-model="props.item.ready_quarter"
                                    label="Стадия строительства"
                                ></v-autocomplete>
                            </template>
                        </v-edit-dialog>
                    </template>


                    <template v-slot:item.actions="{ item }">
                        <v-btn class="mr-1" x-small @click="editYandex(item)">
                            Яндекс
                        </v-btn>
                        <v-btn class="mr-1" x-small @click="editAvito(item)">
                            Авито
                        </v-btn>

                        <v-btn class="mr-1" x-small @click="editCian(item)">
                            ЦИАН
                        </v-btn>

                        <v-btn class='mr-1' x-small
                               @click="updateFeedStatus(item.id, item.is_active ? 'disable' : 'enable')">
                            <v-icon x-small
                                    :color='(item.is_active ? $store.getters.uiAccentIcon : "light-blue darken-1")'>
                                mdi-power
                            </v-icon>
                        </v-btn>
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                        <td></td>
                        <td></td>
                        <td :colspan="headers.length - 10">
                            <v-container>
                                <v-row>
                                    <v-col>
                                        <p>Яндекс - {{ item.is_valid_yandex ? 'Готов' : 'Не готов' }}</p>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </td>
                    </template>


                </v-data-table>
                <div class="text-center pt-2">
                    <v-pagination
                        v-model="page"
                        :length="totalPages"
                        :total-visible="20"
                        circle
                    ></v-pagination>
                </div>
            </template>
        </v-container>
        <project-import-setting
            :initialState.sync="visibility.importSetting"
            :project="this.currentProject"
        ></project-import-setting>
        <project-export-setting
            :initialState.sync="visibility.exportSettings"
            :project="this.currentProject"
        ></project-export-setting>

        <project-yandex-flat-feed-update
            :initialState.sync="visibility.yandexNewBuilding"
            :feed="cursorFeed"
        ></project-yandex-flat-feed-update>
        <project-yandex-commercial-feed-update
            :initialState.sync="visibility.yandexCommercialBuilding"
            :feed="cursorFeed"
        ></project-yandex-commercial-feed-update>
        <project-avito-new-building-feed-update
            :initialState.sync="visibility.avitoNewBuilding"
            :feed="cursorFeed"
        ></project-avito-new-building-feed-update>
        <project-avito-commercial-building-feed-update
            :initialState.sync="visibility.avitoCommercial"
            :feed="cursorFeed"
        ></project-avito-commercial-building-feed-update>
        <project-cian-new-building-feed-update
            :initialState.sync="visibility.cianNewBuilding"
            :feed="cursorFeed"
        ></project-cian-new-building-feed-update>
        <project-cian-commercial-building-feed-update
            :initialState.sync="visibility.cianCommercialBuilding"
            :feed="cursorFeed"
        ></project-cian-commercial-building-feed-update>
        <project-massive-update
            :initialState.sync="visibility.massiveUpdate"
            :feeds="selected"
            :postAction="getOffers"
        ></project-massive-update>

        <project-filter
            :initialState.sync="visibility.filterDialog"
            :data="filterParams"
        >

        </project-filter>
    </v-layout>

</template>


<style>
    .mr-20 {
        margin-right: 20px;
    }

    .ml-20 {
        margin-left: 20px;
    }

    .wb-ba {
        word-break: break-all;
    }

    .wb-bw {
        word-break: break-word;
    }

</style>


<script>
    import ProjectImportSetting from "@/components/entities/import_setting/ImportSettingDialog";
    import ProjectExportSetting from "@/components/entities/export_setting/ExportSettingDialog";
    import YandexFlatFeedUpdateDialog from "@/components/entities/feeds/YandexFlatUpdateDialog";
    import YandexCommercialFeedUpdateDialog from "@/components/entities/feeds/YandexCommercialUpdateDialog";
    import AvitoNewBuildingUpdateDialog from "@/components/entities/feeds/AvitoNewBuildingUpdateDialog";
    import AvitoCommercialBuildingUpdateDialog from "@/components/entities/feeds/AvitoCommercialBuildingUpdateDialog";
    import CianNewBuildingUpdateDialog from "@/components/entities/feeds/CianNewBuildingUpdateDialog";
    import CianCommercialBuildingUpdateDialog from "@/components/entities/feeds/CianCommercialBuildingUpdateDialog";
    import MassiveUpdateDialog from "@/components/entities/feeds/MassiveUpdateDialog";
    import FilterDialog from "@/components/entities/projects/FilterDialog";
    import header from "../plugins/header";
    import filters from "../store/filters";

    export default {
        components: {
            'project-import-setting': ProjectImportSetting,
            'project-export-setting': ProjectExportSetting,
            'project-yandex-flat-feed-update': YandexFlatFeedUpdateDialog,
            'project-yandex-commercial-feed-update': YandexCommercialFeedUpdateDialog,
            'project-avito-new-building-feed-update': AvitoNewBuildingUpdateDialog,
            'project-avito-commercial-building-feed-update': AvitoCommercialBuildingUpdateDialog,
            'project-cian-new-building-feed-update': CianNewBuildingUpdateDialog,
            'project-cian-commercial-building-feed-update': CianCommercialBuildingUpdateDialog,
            'project-massive-update': MassiveUpdateDialog,
            'project-filter': FilterDialog,
            'table-header': header
        },
        data() {
            return {
                selected: [],

                visibility: {
                    importSetting: false,
                    exportSettings: false,
                    update: false,
                    yandexNewBuilding: false,
                    yandexCommercialBuilding: false,
                    avitoNewBuilding: false,
                    avitoCommercial: false,
                    cianNewBuilding: false,
                    cianCommercialBuilding: false,
                    massiveUpdate: false,
                    filterDialog: false
                },
                expanded: [],
                building_name: '',
                page: 1,
                totalFeeds: 0,
                totalPages: 0,
                offers: [],
                filterParams: {
                    building_name: {
                        operand: 7,
                        value: null
                    }
                },
                filterOptions: filters.options,
                options: {},
                pagination: {},
                loading: true,
                project: {},
                cursorFeed: {},
                footerProps: {
                    'items-per-page-options': [20, 50, 100],
                    'prev-icon': 'false',
                    'next-icon': 'false',
                    'items-per-page-text': 'На странице'
                },
                itemsPerPage: 20,
                buildingStateChoices: [
                    {
                        value: 'built',
                        text: 'Дом построен, но не сдан'
                    },
                    {
                        value: 'hand-over',
                        text: 'Сдан в эксплуатацию'
                    },
                    {
                        value: 'unfinished',
                        text: 'Дом строится'
                    },
                ],
                quarterChoices: [
                    {
                        value: 1,
                        text: 1
                    },
                    {
                        value: 2,
                        text: 2
                    },
                    {
                        value: 3,
                        text: 3
                    },
                    {
                        value: 4,
                        text: 4
                    },
                ],
                rules: {
                    checkArea(item) {
                        let op = item.area
                        let ls = item.living_space
                        let ks = item.kitchen_space
                        let check_op = ls + ks
                        if (check_op > op) {
                            this.areaError = true
                            return 'Общая площадь не должна быть меньше ' + check_op
                        } else {
                            this.areaError = false
                            return true
                        }
                    },
                    checkFloor(item) {
                        let fl = item.floor
                        let fl_total = item.floors_total
                        if (fl_total > 0 && fl > fl_total) {
                            this.floorError = true
                            return '"Этажность" не должна быть больше ' + fl_total
                        } else {
                            this.floorError = false
                            return true
                        }
                    }
                }
            }
        },

        methods: {
            importFeeds() {
                this.$http.get(
                    this.$store.getters.endpoint + `/project/${this.currentProject.id}/import_data`, {
                        emulateJSON: true,
                        params: {
                            'login': this.$store.getters.userLogin
                        },
                        headers: this.$store.state.restrictedHeaders
                    }
                ).then(
                    r => {
                        this.indicator = false;
                        let response = r.body;
                    }
                )

            },
            validateFeeds() {
                this.$http.get(
                    this.$store.getters.endpoint + `/project/${this.currentProject.id}/validate`, {
                        emulateJSON: true,
                        params: {
                            'login': this.$store.getters.userLogin
                        },
                        headers: this.$store.state.restrictedHeaders
                    }
                ).then(
                    r => {
                        this.indicator = false;
                        let response = r.body;
                    }
                )

            },
            setBackgroundColor(item) {
                if (!item.is_valid_yandex || !item.is_valid_avito || !item.is_valid_cian) {
                    return 'style-1'
                } else if (!item.is_active) {
                    return 'style-2'
                }
            },
            massiveUpdate() {
                this.visibility.massiveUpdate = true;
            },
            requestProjectDetails() {
                document.title = this.$store.getters.pageTitle + ' | ' + this.currentProject.name;
            },
            kuku(e) {
                console.log(e)
            },
            getOffers() {
                this.indicator = true;
                this.loading = true;
                this.offers = [];
                const {page, itemsPerPage} = this.options;
                const sortParams = {};
                this.options.sortBy.forEach((f, id) => {
                    sortParams[f] = this.options.sortDesc[id] ? 'DESC' : 'ASC'
                })
                const filterParams = {};
                this.filterOptions.forEach((f, id) => {
                    if (f.value && f.operand) {
                        filterParams[f.name] = {
                            operand: f.operand,
                            value: f.name == 'building_name' ? `%${f.value}%` : f.value
                        }
                    }
                });
                const params = {
                    'login': this.$store.getters.userLogin,
                    'page': page,
                    'per_page': itemsPerPage
                };
                if (Object.keys(sortParams).length) {
                    params['sort_params'] = JSON.stringify({...sortParams})
                }
                if (Object.keys(filterParams).length) {
                    params['filter_params'] = JSON.stringify({...filterParams})
                }
                this.$http.get(
                    this.$store.getters.endpoint + `/projects/${this.currentProject.id}/feeds`, {
                        emulateJSON: true,
                        params: params,
                        headers: this.$store.state.restrictedHeaders
                    }
                ).then(
                    r => {
                        let response = r.body;
                        if (response.result) {
                            this.offers = response.data.feeds;
                            this.totalFeeds = response.data.total_count;
                            this.totalPages = response.data.total_pages;
                            this.indicator = false;
                            this.visibility.update = false;

                        }
                    }
                ).finally(() => {
                    this.loading = false;
                })
            },
            updateFeedStatus(item, status) {
                this.indicator = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': 'Bearer ' + String(this.$store.getters.userToken)
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                }
                this.$http.put(
                    this.$store.getters.endpoint + `/feeds/${item}/${status}`, {...requestData},
                    {
                        headers: {...this.$store.state.restrictedHeaders, ...requestHeaders}
                    }
                ).then(
                    r => {
                        let response = r.body;
                        if (response.result) {
                            this.indicator = false;
                            this.getOffers();
                        }
                    }
                )
            },
            editYandex(item) {
                this.cursorFeed = item;
                if (item.building_type === 'new_building') {
                    this.visibility.yandexNewBuilding = true;
                }

                if (item.building_type === 'commercial_building') {
                    this.visibility.yandexCommercialBuilding = true;
                }
            },
            editAvito(item) {
                this.cursorFeed = item;
                if (item.building_type === 'new_building') {
                    this.visibility.avitoNewBuilding = true;
                }

                if (item.building_type === 'commercial_building') {
                    this.visibility.avitoCommercial = true;
                }
            },
            editCian(item) {
                console.log(item)
                this.cursorFeed = item;
                if (item.building_type === 'new_building') {
                    this.visibility.cianNewBuilding = true;
                }

                if (item.building_type === "commercial_building") {
                    this.visibility.cianCommercialBuilding = true;
                }
            },
            saveFeedQuick(item, field) {
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': 'Bearer ' + String(this.$store.getters.userToken)
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                }
                this.$http.put(
                    this.$store.getters.endpoint + `/feeds/${item.id}/quick`,
                    {...requestData, data: [field, item[field]]},
                    {headers: {...this.$store.state.restrictedHeaders, ...requestHeaders}}
                ).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        // console.log(response)
                    } else {
                        // console.log(response)
                    }
                })
            },
            onChangedFilters() {
                this.getOffers();
            },
            clearFilters() {
                this.filterOptions.forEach(e => {
                    e.selected = false;
                    if (e.name != 'building_name') {
                        e.operand = null;
                    }
                    e.value = null;
                });
                this.getOffers();
            },
            clearFilter(e) {
                this.filterOptions[e].value = null;
                if (this.filterOptions[e].name != 'building_name') {
                    this.filterOptions[e].operand = null;
                }
                this.getOffers();
            },
            buildingStateTitle(state) {
                if (state) {
                    return this.buildingStateChoices.find(el => el.value == state).text;
                }
                return 'Н/Д'
            },
            editImportSetting() {

            },
            setMinValArea(item) {
                if (item.living_space + item.kitchen_space > item.area) {
                    item.area = item.living_space + item.kitchen_space
                }
            },
            setMinArea(item) {
                let min_area = item.living_space + item.kitchen_space
                return min_area
            },
            setMaxFloor(item) {
                if (item.floors_total > 0) {
                    return item.floors_total
                }
            },
            setMaxValFloor(item) {
                if (item.floors_total > 0 && item.floor > item.floors_total) {
                    item.floor = item.floors_total
                }
            },
        },
        watch: {
            '$route'(to, from) {
                if (to.name == 'project') {
                    if (to && to.params && Object.keys(to.params).length > 1) {
                        this.$store.commit('cursorProject', to.params);
                    } else {
                        const project = this.$store.getters.userObjects.filter((p) => p.id == to.params.id)[0]
                        this.$store.commit('cursorProject', project);
                    }
                    this.requestProjectDetails()
                }
            },
            options: {
                handler() {
                    setTimeout(() => {
                        this.getOffers();
                    }, 500)
                }
            },
            currentProject() {
                if (Object.keys(this.currentProject).length) {
                    this.$store.commit('setBreadcrumbs', [
                        {text: 'Главная', disabled: false, to: '/', ripple: true},
                        {
                            text: this.currentProject.name,
                            disabled: true,
                            to: '/p/' + this.currentProject.id,
                            ripple: true
                        }
                    ]);
                }
            }
        },
        computed: {
            filtersEnabledCount() {
                const enabledFilters = this.filterOptions.filter(e => {
                    return e.operand && e.value || !e.operand && e.value;
                });
                return enabledFilters.length;
            },
            currentProject() {
                return this.$store.state.currentProject
            },
            headers() {
                return [
                    {
                        text: 'ID',
                        value: 'id'
                    },
                    {
                        text: 'Внешний ID',
                        value: 'external_id'
                    },
                    {
                        text: 'Название ЖК',
                        value: 'building_name',
                        align: 'left',
                    },
                    {
                        text: 'Цена',
                        value: 'price',
                        align: 'center',
                    },
                    {
                        text: 'ОП',
                        value: 'area',
                        align: 'center',
                        // width: 85
                    },
                    {
                        text: 'ЖП',
                        value: 'living_space',
                        align: 'center',
                        // width: 105,
                    },
                    {
                        text: 'ПК',
                        value: 'kitchen_space',
                        align: 'center',
                        // width: 15,
                    },
                    {
                        text: 'Комнатность',
                        value: 'rooms',
                        align: 'center',
                        class: 'wb-ba',
                        // width: 80,
                    },
                    {
                        text: 'Этаж',
                        value: 'floor',
                        align: 'center',
                        // width: 15,
                    },
                    {
                        text: 'Этажность',
                        value: 'floors_total',
                        class: 'll',
                        align: 'center',
                        // width: 65,
                    },
                    {
                        text: 'Ипотека',
                        value: 'mortgage',
                        align: 'center',
                        // width: 65
                    },
                    // {
                    //     text: 'Год сдачи',
                    //     value: 'built_year',
                    //     align: 'center',
                    // },
                    // {
                    //     text: 'Кв сдачи',
                    //     value: 'ready_quarter',
                    //     align: 'center',
                    //     class: 'wb-bw',
                    //     // width: 79
                    // },
                    // {
                    //     text: 'Стадия строительства',
                    //     value: 'building_state',
                    //     align: 'center',
                    // },
                    {text: 'Действия', value: 'actions', sortable: false},
                ]
            },
            mortgageCompute(item) {
                return item.mortgage ? 'Да' : 'Нет';
            }

        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.$store.subscribe((mutation, state) => {
                    if (mutation.type == 'cursorProject') {
                        console.log('p', mutation)
                        if (mutation.payload && Object.keys(mutation.payload).length > 0) {
                            vm.requestProjectDetails()
                        } else {
                            vm.$router.push({'path': '/'});
                        }
                    }
                });
                if (from.name || Object.keys(to.params).includes('id')) {
                    const project = vm.$store.getters.userObjects.filter((p) => p.id == to.params.id)[0]
                    console.log(222, from, to)
                    vm.$store.commit('cursorProject', project);
                    // vm.getOffers()
                }
            });
        }

    }
</script>
